import type { GoalProgressDetail } from '../../services/api/types.gen';
import { parseISOToLocalDate } from '../../utils/dateUtils';

export function getMostRecentProgressWithScore(
  progressHistory: GoalProgressDetail[] | undefined
): GoalProgressDetail | null {
  if (!progressHistory?.length) return null;
  const withScore = progressHistory.filter(p => p.progress_score != null);
  if (withScore.length === 0) return null;
  const sorted = [...withScore].sort(
    (a, b) =>
      (parseISOToLocalDate(b.task_date)?.getTime() ?? 0) -
      (parseISOToLocalDate(a.task_date)?.getTime() ?? 0)
  );
  return sorted[0] ?? null;
}

/**
 * The progress record a goal card should headline on a given visit: the
 * record documented on that visit when there is one, otherwise the most
 * recent scored record on the goal. Without the visit preference, a score
 * edited on an older visit (e.g. one QA returned) never shows because a
 * later visit's record wins on date.
 */
export function getProgressForVisit(
  progressHistory: GoalProgressDetail[] | undefined,
  visitId: string
): GoalProgressDetail | null {
  const onThisVisit = progressHistory?.find(
    p => p.task_id === visitId && p.progress_score != null
  );
  return onThisVisit ?? getMostRecentProgressWithScore(progressHistory);
}
